
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import SponsorsSection from './components/SponsorsSection';
import AboutSection from './components/AboutSection';
import AppFeaturesSection from './components/AppFeaturesSection';
import GallerySection from './components/GallerySection';
import RegistrationSection from './components/RegistrationSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <SponsorsSection />
        <AboutSection />
        <AppFeaturesSection />
        <GallerySection />
        <RegistrationSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}
